import { Locale } from '@finxone-platform/shared/enums';
import { AlertTypes, NotificationTemplateEnum } from '@finxone-platform/shared/sys-config-types';

export const beneficiaryInAppTranslations = {
  [Locale.en_GB]: {
    ADD_BENEFICIARY_TITLE: 'A new beneficiary has been added to your account: {{beneficiaryName}}',
    ADD_BENEFICIARY_DESCRIPTION: 'View beneficiary details',
    UPDATE_BENEFICIARY_TITLE: "{{beneficiaryName}}'s details were updated",
    UPDATE_BENEFICIARY_DESCRIPTION: 'View beneficiary details',
    REMOVE_BENEFICIARY_TITLE: '{{beneficiaryName}} was removed as a beneficiary',
    REMOVE_BENEFICIARY_DESCRIPTION: 'View details of the removed beneficiary',
  },
  // Add more locales as needed
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generateBeneficiaryInAppAlerts = (translations: any) => ({
  [NotificationTemplateEnum.ADD_BENEFICIARY]: {
    name: 'Add Beneficiary',
    type: AlertTypes.INFO,
    title: translations.ADD_BENEFICIARY_TITLE,
    description: translations.ADD_BENEFICIARY_DESCRIPTION,
  },
  [NotificationTemplateEnum.UPDATE_BENEFICIARY]: {
    name: 'Update Beneficiary',
    type: AlertTypes.INFO,
    title: translations.UPDATE_BENEFICIARY_TITLE,
    description: translations.UPDATE_BENEFICIARY_DESCRIPTION,
  },
  [NotificationTemplateEnum.REMOVE_BENEFICIARY]: {
    name: 'Remove Beneficiary',
    type: AlertTypes.INFO,
    title: translations.REMOVE_BENEFICIARY_TITLE,
    description: translations.REMOVE_BENEFICIARY_DESCRIPTION,
  },
});
